import { create } from 'zustand';

export const useUserStore = create(set => ({
  accessToken: null,
  setAccessToken: token => set({ accessToken: token }),
  clearTokens: () => set({ accessToken: null }),
}));